(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ml-preorder-actions"] && !Shopify.designMode) return;
  try {
    // Watch for the theme setting data-added="true" on the preorder button
  (function() {
    function initPreorderObserver() {
      var btn = document.querySelector('.ml-preorder-btn');
      if (!btn) return;

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'data-added') {
            if (btn.dataset.added === 'true') {
              btn.classList.add('ml-po-success');
            } else {
              btn.classList.remove('ml-po-success');
            }
          }
        });
      });

      observer.observe(btn, { attributes: true, attributeFilter: ['data-added'] });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPreorderObserver);
    } else {
      initPreorderObserver();
    }
  })();

  window.mlWaitlistSubmit = function(event, form) {
    event.preventDefault();

    var phone = form.querySelector('input[name="phone"]').value.trim();
    var productId = form.dataset.productId;
    var variantId = form.dataset.variantId;
    var productTitle = form.dataset.productTitle;
    var wrap = form.closest('.ml-waitlist-form-wrap');

    if (!phone) return;

    var btn = form.querySelector('.ml-waitlist-form__btn');
    btn.disabled = true;
    btn.textContent = '...';

    var handle = form.dataset.productHandle || '';
    fetch('https://script.google.com/macros/s/AKfycbzG3jptKiGrwubJw-123ectLkapf5pjKQNcuHMdJEJ2CChSnC5ujsTbNKbtonpeFYO-ZA/exec', {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        phone: phone,
        product: productTitle,
        variant: variantId,
        handle: handle
      })
    }).finally(function() {
      form.style.display = 'none';
      wrap.querySelector('.ml-waitlist-success').style.display = 'flex';
    });
  }
  } catch(e) { console.error(e); }
})();

})();
